import axios from 'axios';
import store from '../index';
import { userLoaded } from '../actions/auth';
import { Logout } from '../middlewares/auth';
import { GetCookie } from '../../utils/cookie';
import { currentApp } from '../apps';

export const axiosInstance = axios.create({
    // See application/apps.ts for how the base URL is chosen.
    baseURL: currentApp().apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: null,
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const originalRequest = error.config;
        const refreshToken = GetCookie(currentApp().refreshCookie);
        if (error.response.status === 401 && error.response.data === 'Unauthorized' && refreshToken) {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                    Authorization: `Bearer ${refreshToken}`,
                },
                withCredentials: true,
            };
            return axiosInstance
                .get('api/v1/auth/token-refresh', config)
                .then((response) => {
                    console.log(response);
                    axiosInstance.defaults.headers.Authorization = `Bearer ${response.data.token}`;
                    originalRequest.headers.Authorization = `Bearer ${response.data.token}`;
                    store.dispatch(userLoaded(response.data));
                    return axiosInstance(originalRequest);
                })
                .catch((err) => {
                    console.log('Error on api', err);
                    axiosInstance.defaults.headers.Authorization = null;
                    originalRequest.headers.Authorization = null;
                    store.dispatch(Logout());
                    return Promise.reject(error);
                });
        } else {
            axiosInstance.defaults.headers.Authorization = null;
            originalRequest.headers.Authorization = null;
            //store.dispatch(Logout());
            return Promise.reject(error);
        }
    },
);

export const api = {
    get: async ({ url, token }: { url: string; token: string }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.get(url, config);
    },
    post: async ({ url, token, params }: { url: string; token: string; params: any }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.post(url, params, config);
    },
    update: async ({ url, token, params }: { url: string; token: string; params: any }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.put(url, params, config);
    },
    // Partial update of one field group (the trainer's item readings, D111).
    patch: async ({ url, token, params }: { url: string; token: string; params: any }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.patch(url, params, config);
    },
    delete: async ({ url, token }: { url: string; token: string }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.delete(url, config);
    },
    upload: async ({ url, token, formData }: { url: string; token: string; formData: any }) => {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            },
        };
        return await axiosInstance.post(url, formData, config);
    },
};
